import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx="26" cy="26" fill="#f3f2f1" r="26" /><path d="M40.49 17.33l-16 18A2 2 0 0123 36a2 2 0 01-1.25-.44l-10-8a2 2 0 012.5-3.12l8.52 6.81L37.5 14.67a2 2 0 113 2.66z" fill="#d3d3d3" /></svg>;